import React from 'react';
import type { SearchCriteria } from '../../types';

export interface UseSearchProp<T> {
  createEmptyCriteria(): SearchCriteria<T>;
  onCriteriaChanged?: () => void;
}

export interface SearchState<T> extends SearchCriteria<T> {
  updateSearchText: (text: string) => void;
  setFilters: (filters: T) => void;
  reset: () => void;
}

export function useSearch<T>({
  createEmptyCriteria,
  onCriteriaChanged,
}: UseSearchProp<T>): SearchState<T> {
  const [criteria, setCriteria] = React.useState<SearchCriteria<T>>(createEmptyCriteria());

  const reset = React.useCallback(async () => {
    setCriteria(createEmptyCriteria());
    onCriteriaChanged?.();
  }, [createEmptyCriteria, onCriteriaChanged]);

  const updateSearchText = (text: string) => {
    setCriteria((prev) => ({ ...prev, searchText: text }));
    onCriteriaChanged?.();
  };

  const setFilters = async (filters: T) => {
    setCriteria((prev) => ({ ...prev, filters }));
    onCriteriaChanged?.();
  };

  return { ...criteria, updateSearchText, setFilters, reset };
}
